import { InputAdornment, TextField } from '@mui/material';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { handleHousingDeposits, validDecimalAndLength } from '../../ModificationsUtils';

export const PetDepositAmount = () => {
  const { control, getValues, setValue } = useFormContext();
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isModEdit = useSelector(selectIsEditMod);
  const { t } = useTranslation();
  const petDespositAmount = 'petDespositAmount';
  const petDespositAmountWatch: number = useWatch({ name: petDespositAmount });
  const handleChange = (value: string) => {
    setValue(petDespositAmount, value);
    const updateValues = handleHousingDeposits(getValues('deposits'), 1, value ? value : '0', 'amount');
    setValue('deposits', updateValues);
  };
  return (
    <Controller
      control={control}
      name={petDespositAmount}
      rules={{
        required: false,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={getValues(petDespositAmount) ?? ''}
          onChange={e => {
            if (validDecimalAndLength(e.target.value, { numberLength: 6, decimalLength: 2 })) {
              const validInput = e.target.value.replace(/^\./, '0.');
              handleChange(validInput);
              onChange(validInput);
            }
          }}
          InputLabelProps={{
            shrink: petDespositAmountWatch ? true : false,
          }}
          InputProps={{
            readOnly: !isModEdit,
            style: {
              pointerEvents: !isModEdit ? 'none' : 'auto',
            },
            startAdornment: <>{value && <InputAdornment position="start">{t('currency.dollar')}</InputAdornment>}</>,
          }}
          variant="filled"
          fullWidth
          id="petDespositAmount"
          color="primary"
          autoComplete="off"
          label={t('placement.placementMods.petDespositAmount')}
          disabled={isSaveModApiCalling}
          {...rest}
        />
      )}
    />
  );
};
